<template>
  <div>
    <!-- Header avec navigation -->
    <HeaderPage>
      <br>
      <!-- Filtres par date -->
      <div class="container mt-4">
        <p class="col-12 text-center">
          Veuillez rechercher des articles disponibles en sélectionnant une plage de dates.
        </p>
        <div class="col-12 text-center">
          <div class="col-md-2">
            <label for="dateDebut" class="form-label" style="margin-left: 300px;">Date </label>
            <input type="date" v-model="dateDebut" id="dateDebut" class="form-control" style="width: 200px; height: 50px; margin-left: 300px;" />
          </div>
          <div class="col-md-4">
            <!-- <label for="dateFin" class="form-label" style=" margin-left: 550px; margin-top: -10000px;">Date Fin</label> -->
            <input type="date" v-model="dateFin" id="dateFin" class="form-control" style="width: 200px; height: 50px; margin-left: 550px; margin-top: -50px;" />
          </div>
          <div class="col-md-1">
            <label class="form-label">.</label>
            <button @click="fetchArticlesByDate" class="btn btn-primary" style="width: 150px; height: 50px; margin-left: 800px; margin-top: -145px">Filtrer</button>
          </div>
        </div>
        <!-- Contenu principal -->
        <h2 v-if="hasSearched" class="text-center">Immobilisations disponibles :</h2>
        <br>
        <br>
        <!-- Affichage des résultats -->
        <div v-if="hasSearched">
          <div class="d-flex justify-content-center mb-4">
  <button @click="isListView = true" class="btn btn-sm btn-outline-secondary mx-5 btn-fixed-width " style="width: 20px; height: 50px;">
    Afficher en mode liste
  </button>
  <button @click="isListView = false" class="btn btn-sm btn-outline-secondary mx-5 btn-fixed-width" style="width: 20px; height: 50px;">
    Afficher en mode carte
  </button>
</div>

          <!-- Aucun article trouvé -->
          <div v-if="articles.length === 0" class="no-articles text-center">
            <p>Aucun article disponible.</p>
          </div>
          
          <!-- Mode liste -->
          <div v-if="isListView" class="table-responsive">
            <table id="datatablesSimple" class="table table-bordered">
              <thead>
                <tr>
                  <th>Choisir</th>
                  <th>Nom de l'article</th>
                  <th>Description</th>
                  <th>Quantité</th>
                  <th>Prix unitaire (en Ariary)</th>
                </tr>
              </thead>
            </table>
          </div>
          <!-- Mode carte -->
          <div v-else class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
            <ArticleCard
              v-for="article in articles"
              :key="article.id"
              :article="article"
              :isSelected="selectedArticles.includes(article.id)"
              @toggle-select="toggleArticleSelection"
            />
          </div>

          <!-- Bouton pour ajouter au panier -->
          <div class="d-flex justify-content-center mt-4">
            <button @click="addToCart" class="btn btn-success">Reserver</button>
          </div>
        </div>
      </div>
    </HeaderPage>

    <!-- Modal Bootstrap pour le Panier -->
    <div
      class="modal fade"
      id="cartModal"
      tabindex="-1"
      aria-labelledby="cartModalLabel"
      aria-hidden="true"
      ref="cartModalRef"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="cartModalLabel">Immobilisations</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
          </div>
          <div class="modal-body">
            <!-- Contenu du panier -->
            <div class="cart">
              <h2 class="text-primary">Informations du client</h2>
              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <input type="text" v-model="clientName" class="form-control" placeholder="Nom" required />
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <input type="text" v-model="clientSurname" class="form-control" placeholder="Prénom" required />
                </div>
                <div class="col-12 mb-3">
                  <input type="text" v-model="clientAddress" class="form-control" placeholder="Adresse" required />
                </div>
                <div class="col-12 mb-3">
                  <input type="text" v-model="clientContact" class="form-control" placeholder="Contact" required />
                </div>
              </div>

              <h2 class="text-primary mb-4">🛒 Articles à réserver</h2>
              <div v-if="cart.length > 0" class="row">
                <div class="col-md-12">
                  <ul class="list-unstyled">
                    <li 
                      v-for="article in cart" 
                      :key="article.id + '-' + article.dateLocation.debut + '-' + article.dateLocation.fin"
                      class="d-flex align-items-center justify-content-between p-2 border-bottom"
                    >
                      <!-- Nom de l'article -->
                      <span class="fw-bold">{{ article.nom_article }}</span>

                      <!-- Date de location -->
                      <small class="text-muted">
                        📅 {{ formatDateFr(article.dateLocation.debut) }} - {{ formatDateFr(article.dateLocation.fin) }}
                      </small>



                      <!-- Type de tarif -->
                      <select v-model="article.type_location" class="form-select form-select-sm w-auto">
                        <option value="forfaitaire">Forfaitaire</option>
                        <option value="jour">Par jour</option>
                      </select>

                      <!-- Prix -->
                      <div>
                        <template v-if="article.type_location === 'jour'">
                          <span class="badge bg-success">
                            {{ calculateDays(article.dateLocation.debut, article.dateLocation.fin) * article.quantite * article.prix }} Ar
                          </span>
                        </template>
                        <template v-else>
                          <input type="number" v-model.number="article.forfaitairePrice" class="form-control form-control-sm" placeholder="Prix forfaitaire" />
                        </template>
                      </div>

                      <!-- Quantité -->
                      <input 
                        type="number" 
                        v-model="article.quantite" 
                        :max="article.quantiteDisponible"
                        min="1"
                        class="form-control form-control-sm w-25"
                      />

                      <!-- Bouton de suppression -->
                      <button @click="removeArticle(article.id, article.dateLocation)" class="btn btn-danger btn-xs">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </li>
                  </ul>
                </div>

                <!-- Résumé et validation -->
                <div class="col-md-4">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <h5 class="card-title">
                          Total : <strong class="text-primary">{{ formatPrix(totalPrix) }} Ariary</strong>
                      </h5>
                      <button @click="validateCart" class="btn btn-primary w-100 mt-3">
                         Valider
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Panier vide -->
              <div v-else class="alert alert-warning text-center">
                🛑 Panier vide.
              </div>
              
              <p v-if="successMessage" class="text-success mt-3 text-center">{{ successMessage }}</p>              
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin de la modal -->
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import ArticleCard from './components/ArticleCard.vue';
import HeaderPage from './components/HeaderPage.vue';
import './assets/styleHome.css';
import { Modal } from 'bootstrap';

const router = useRouter();
const API_URL = process.env.VUE_APP_API_URL;

// --- Fonctions utilitaires et calculs de date ---
function formatDate(date) {
  return date.toISOString().split('T')[0];
}

function formatPrix(valeur) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'decimal',
    minimumFractionDigits: 0
  }).format(valeur);
}



function formatDateFr(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}


function calculateDays(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffTime = endDate - startDate;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Calcul inclusif
  return diffDays;
}

const today = new Date();
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

// --- Variables d'état de la homepage ---
const isListView = ref(true);
const articles = ref([]);
const selectedArticles = ref([]);
const cart = ref(JSON.parse(localStorage.getItem('cart')) || []);
const dateDebut = ref(formatDate(firstDayOfMonth));
const dateFin = ref(formatDate(lastDayOfMonth));
const hasSearched = ref(false);

// --- Variables pour le panier ---
const clientName = ref('');
const clientSurname = ref('');
const clientAddress = ref('');
const clientContact = ref('');
const validatedCart = ref([]);
const successMessage = ref('');
const showInvoice = ref(false);

// --- Computed pour le total des prix ---
const totalPrix = computed(() => {
  return cart.value.reduce((total, article) => {
    if (article.type_location === 'jour') {
      const days = calculateDays(article.dateLocation.debut, article.dateLocation.fin);
      return total + days * article.quantite * article.prix;
    } else {
      return total + (article.forfaitairePrice || 0);
    }
  }, 0);
});

// --- Références pour la modal Bootstrap ---
const cartModalRef = ref(null);

// --- Fonctions de gestion des articles ---
function toggleArticleSelection(articleId) {
  if (selectedArticles.value.includes(articleId)) {
    selectedArticles.value = selectedArticles.value.filter(id => id !== articleId);
  } else {
    selectedArticles.value.push(articleId);
  }
}

function removeArticle(articleId, dateLocation) {
  cart.value = cart.value.filter(article =>
    !(article.id === articleId &&
      article.dateLocation.debut === dateLocation.debut &&
      article.dateLocation.fin === dateLocation.fin)
  );
  localStorage.setItem('cart', JSON.stringify(cart.value));
}

// --- Fonction d'ajout au panier modifiée pour ouvrir la modal ---
function addToCart() {
  if (selectedArticles.value.length === 0) {
    alert("Veuillez sélectionner au moins un article.");
    return;
  }

  selectedArticles.value.forEach(articleId => {
    const article = articles.value.find(a => a.id === articleId);
    if (article) {
      const articleWithDate = {
        ...article,
        dateLocation: {
          debut: dateDebut.value,
          fin: dateFin.value
        },
        quantiteDisponible: article.quantite_disponible,
        quantite: 1,
        type_location: 'forfaitaire', // Type par défaut
        forfaitairePrice: article.prix // Valeur par défaut pour forfaitaire
      };

      const existingItem = cart.value.find(item =>
        item.id === articleWithDate.id &&
        item.dateLocation.debut === articleWithDate.dateLocation.debut &&
        item.dateLocation.fin === articleWithDate.dateLocation.fin
      );

      if (!existingItem) {
        cart.value.push(articleWithDate);
      }
    }
  });
  localStorage.setItem('cart', JSON.stringify(cart.value));
  selectedArticles.value = [];
  openCartModal();
}

// --- Fonction pour ouvrir la modal du panier ---
function openCartModal() {
  const modalEl = cartModalRef.value;
  const modal = new Modal(modalEl);
  modal.show();
}

// --- Récupérer les articles par date ---
async function fetchArticlesByDate() {
  const token = localStorage.getItem('token');

  if (!dateDebut.value || !dateFin.value) {
    alert("Veuillez sélectionner une date de début et une date de fin.");
    return;
  }

  try {
    const response = await axios.post(`${API_URL}/api/user/articles_Date`, {
      dateDebut: dateDebut.value,
      dateFin: dateFin.value,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    articles.value = response.data;
    hasSearched.value = true;
    initDataTable();
  } catch (error) {
    console.error('Erreur lors de la récupération des articles :', error);
    alert("Une erreur est survenue lors de la récupération des articles.");
  }
}

// --- Initialisation de DataTable ---
function initDataTable() {
  $(document).ready(function () {
    if ($.fn.DataTable.isDataTable('#datatablesSimple')) {
      $('#datatablesSimple').DataTable().destroy();
    }

    $('#datatablesSimple').DataTable({
      data: articles.value,
      columns: [
        {
          data: null,
          render: function (data, type, row) {
            return `<input type="checkbox" class="select-checkbox" data-id="${row.id}" />`;
          },
          orderable: false
        },
        { data: 'nom_article' },
        { data: 'description_article' },
        { data: 'quantite_disponible' },
        {
          data: 'prix',
          className: 'text-end',
          render: function (data) {
            return Number(data).toLocaleString('fr-FR') + ' Ar';
          }
        }

      ],
      infoCallback: function(settings, start, end, max, total) {
        return 'Showing ' + start + ' to ' + end + '\nof ' + total + ' entries';
      }
    });

    $('#datatablesSimple').on('change', '.select-checkbox', function () {
      const articleId = parseInt($(this).data('id'));
      if (this.checked) {
        if (!selectedArticles.value.includes(articleId)) {
          selectedArticles.value.push(articleId);
        }
      } else {
        selectedArticles.value = selectedArticles.value.filter(id => id !== articleId);
      }
    });
  });
}

// --- Validation du panier (envoi au serveur) ---
async function validateCart() {
  let allValid = true;
  successMessage.value = '';

  cart.value.forEach(article => {
    article.errorMessage = '';
    if (article.quantite > article.quantiteDisponible) {
      article.errorMessage = 'Quantité insuffisante';
      allValid = false;
    }
  });

  if (!clientName.value || !clientSurname.value || !clientAddress.value || !clientContact.value) {
    alert("Veuillez remplir toutes les informations du client.");
    return;
  }

  if (allValid) {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/api/locations/create-with-client`, {
        client_nom: clientName.value,
        client_telephone: clientContact.value,
        client_adresse: clientAddress.value,
        date_debut: cart.value[0]?.dateLocation.debut || '',
        date_fin: cart.value[0]?.dateLocation.fin || '',
        articles: cart.value.map(article => ({
          article_id: article.id,
          quantite: article.quantite,
          type_location: article.type_location,
          prix: article.type_location === 'jour' 
            ? calculateDays(article.dateLocation.debut, article.dateLocation.fin) * article.quantite * article.prix 
            : article.forfaitairePrice
        }))
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      successMessage.value = 'Votre location a été validée avec succès !';
      validatedCart.value = [...cart.value];
      cart.value = [];
      localStorage.removeItem('cart');
      showInvoice.value = true;
      router.push({ name: 'AddLocation' }); 
    } catch (error) {
      console.error('Erreur lors de la validation du panier:', error);
      alert('Une erreur est survenue lors de la validation.');
    }
  }
}

// --- Montage du composant ---
onMounted(() => {
  $(document).ready(() => {
    $('#datatablesSimple').DataTable();
  });
});
</script>

<style scoped>
/* Styles pour DataTable */

.btn-fixed-width {
    min-width: 200px; /* adapte cette valeur si besoin */
  }
  
.dataTables_info {
  white-space: pre-wrap;
  text-align: center;
  margin-top: 10px;
}

.dataTables_paginate ul.pagination {
  display: flex;
  flex-direction: row;
  justify-content: center; /* Centrer la pagination */
  list-style: none;
  padding: 0;
  margin: 1em 0;
}

.dataTables_paginate ul.pagination li {
  margin: 0 5px;
}

.dataTables_paginate ul.pagination li a {
  display: block;
  padding: 6px 12px;
  color: #007bff;
  text-decoration: none;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.dataTables_paginate ul.pagination li.active a {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}


.btn-xs {
  width: 50px;
}

/* Styles généraux */
.table-container {
  width: 100%;
  overflow-x: auto;
}

.article-table input[type="checkbox"] {
  cursor: pointer;
  margin: 0 auto;
}

.home-container {
  margin-top: 20px;
  padding: 20px;
}

/* Filtres et boutons */
.date-filters {
  display: flex;
  justify-content: space-between;
}

.date-input {
  margin-left: 5px;
}

.filter-btn {
  background-color: #7160ce;
  color: white;
  border: none;
  cursor: pointer;
}

.filter-btn:hover {
  background-color: #5b4bbf;
}

/* Mode carte */
.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

/* Style du DataTable */
.article-table {
  width: 100%;
  margin-top: 20px;
}

.article-table th,
.article-table td {
  padding: 10px;
}
.text-end {
  text-align: right;
}

/* Responsive */
@media (max-width: 768px) {
  .filter-btn {
    width: 100%;
  }
}
</style>
